/** Small, explicitly selected fields transferred from the storefront, never URL-encoded photos. */
export interface StorefrontPrefill {
  version: 1;
  startText: string;
  startLabel: string;
  startImage: string;
  pairImage: string;
  caption: string;
}

const photo = (value: unknown): value is string => typeof value === 'string' && value.length <= 3_000_000 && /^data:image\/jpeg;base64,(?:[a-zA-Z0-9+/]{4})*(?:[a-zA-Z0-9+/]{2}==|[a-zA-Z0-9+/]{3}=)?$/.test(value) && value.length > 23;

export function isStorefrontPrefill(value: unknown): value is StorefrontPrefill {
  if (!value || typeof value !== 'object') return false;
  const v = value as Record<string, unknown>;
  return v.version === 1 && typeof v.startText === 'string' && v.startText.length <= 300 &&
    typeof v.startLabel === 'string' && v.startLabel.length <= 24 &&
    typeof v.caption === 'string' && v.caption.length <= 120 && photo(v.startImage) && photo(v.pairImage);
}

export function storefrontPrefillId(params: URLSearchParams): string {
  const id = params.get('prefill') || '';
  return /^[a-f0-9-]{24,64}$/.test(id) ? id : '';
}

/** A homepage attempt must not reuse or overwrite an older game for this product. */
export function storefrontStorageSuffix(params: URLSearchParams): string {
  const id = storefrontPrefillId(params);
  return id ? `_storefront_${id}` : '';
}

export function prefillFormValues(seed: StorefrontPrefill): Record<string, unknown> {
  const file = (data: string, name: string) => {
    const bytes = Uint8Array.from(atob(data.split(',')[1]), (c) => c.charCodeAt(0));
    return new File([bytes], name, { type: 'image/jpeg' });
  };
  const start = file(seed.startImage, 'welcome.jpg');
  return {
    startGameHeader: seed.startText,
    startLabel: seed.startLabel,
    startGameImage: start,
    gameTiles: [file(seed.pairImage, 'memory-01.jpg'), '', '', '', '', ''],
    gameTileCaptions: [seed.caption, '', '', '', '', ''],
    language: 'ru',
  };
}
